
<div [formGroup]="personneForm">
    <legend class="label-form-cnaf">Vos ressources nettes imposables  cumulées des 12 derniers mois
        <ng-cnaf-aide idDiv="idInfoRessources_{{typePersonne}}" alt="Informations spécifiques à ces champs" data-container="body" (click)="clickPopup(typePersonne)">
        </ng-cnaf-aide>
        </legend>
        
    <p class="bloc-info">
        <img class="img-info" src="/icfstatiquesangularappli/dist/images/InformationsGris.png" alt="">
        <span *ngIf="typePersonne == typePersonneEnum.DEMANDEUR" 
                    class="texte-clair-cnaf" style="padding-left: 15px;margin: 0px;">
                    Vous êtes travailleur indépendant depuis moins deux ans. Vous devez indiquer dans la rubrique "Revenu ou déficit de travailleur indépendant" 
                    votre chiffre d'affaires des 12 derniers mois après déduction de l'abattement lié à votre activité (artisan : 50%, commerçant : 71%, 
                    profession libérale : 34%, profession agricole : 87%).
        </span>
        <span *ngIf="typePersonne == typePersonneEnum.CONJOINT"
                    class="texte-clair-cnaf" style="padding-left: 15px;margin: 0px;">
                    Votre conjoint est travailleur indépendant depuis moins deux ans. Vous devez indiquer dans la rubrique "Revenu ou déficit de travailleur indépendant" 
                    son chiffre d'affaires des 12 derniers mois après déduction de l'abattement lié à son activité (artisan : 50%, commerçant : 71%, 
                    profession libérale : 34%, profession agricole : 87%).
        </span>

        <app-ressources 
                name="ressources"
                [profil]="profilRessources" 
                [ressourceModel]="personneModel.ressources"
                (ressourceModelEvent)="recupererRessources($event)">
        </app-ressources>
        
        <app-sitpro 
                name="sitro"
                id="sitro_{{profilRessources}}"
                [sitProModel]="personneModel.sitPro"
                [typePersonne]="typePersonne" 
                [ressources]="personneModel.ressources"
                [nbEnfants]="nbEnfants"
                (sitProEvent)="recupererSitPro($event)">
        </app-sitpro>
        
    </p>
</div>

<!-- Popup d'aide pour choisir son lieu de résidence parmi les propositions -->
<div id="idInfoRessources_{{typePersonne}}" class="hidden" role="tooltip" tabindex="-1" aria-hidden="true">
    <span>Le montant des ressources nettes imposables figure sur le justificatif de ressources dans la rubrique «Montant à déclarer». Vous ne devez pas déclarer le montant net qui est perçu.</span>
</div>

